import React from "react";
import { Datagrid, ListContextProvider, useListContext, useRecordContext, useTranslate } from "react-admin";
import { Accordion, AccordionDetails, AccordionSummary, Button, IconButton, makeStyles, Typography } from "@material-ui/core";
import { Clear, ExpandMore } from "@material-ui/icons";

import { useList } from "./ra/useList";
import { ListView } from "./cards/ListCard";

const useStyles = makeStyles(theme => ({
  accordion: {
    marginTop: theme.spacing(2),
    borderRadius: theme.shape.borderRadius,
    border: `1px solid ${theme.palette.divider}`,
    '&:before': {
      display: 'none',
    },
  },
  accordionDetails: {
    paddingTop: 0,
  },
  listContainer: {
    width: '100%',
  },
  removeButton: {
    float: 'right',
  }
}));

const RemoveButton = ({ onRemove }) => {
  const { ids, page, setPage } = useListContext();
  const record = useRecordContext();
  const classes = useStyles();

  const handleRemove = () => {
    if (page !== 1 && ids.length === 1) {
      setPage(page - 1);
    }
    onRemove(record);
  }

  return <IconButton className={classes.removeButton} size="small" onClick={handleRemove}>
    <Clear />
  </IconButton>
}

const SelectedItems = ({
  title,
  items = [],
  actions = [],
  noResultsText,
  onRemove,
  onRemoveAll,
  children,
}) => {
  const translate = useTranslate();
  const classes = useStyles();

  const context = useList({
    data: items,
    loaded: true,
    loading: false,
    page: 1,
    perPage: 10,
  });

  const showRemoveButton = typeof onRemove === 'function';
  const showRemoveAllButton = !!items?.length && typeof onRemoveAll === 'function';

  const handleRemoveAll = () => {
    context.setPage(1);
    onRemoveAll();
  }

  const allActions = [
    ...(actions?.length ? actions : []),
    showRemoveAllButton && <Button color="primary" size="small" onClick={handleRemoveAll}>{translate("resources.officials.actions.remove_all")}</Button>
  ].filter(Boolean);

  return (
    <Accordion className={classes.accordion}>
      <AccordionSummary expandIcon={<ExpandMore />}>
        <Typography variant="subtitle1">
          {translate(title, items.length || 0)}
        </Typography>
      </AccordionSummary>
      <AccordionDetails className={classes.accordionDetails}>
        <ListContextProvider value={context}>
          <div className={classes.listContainer}>
            <ListView open actions={allActions} noResultsText={noResultsText} compactToolbar>
              <Datagrid>
                {children}
                {showRemoveButton && <RemoveButton onRemove={onRemove} />}
              </Datagrid>
            </ListView>
          </div>
        </ListContextProvider>
      </AccordionDetails>
    </Accordion>
  );
};

export default SelectedItems;
